'use strict';/* global define */define('modules/custom-forms/services/custom-forms-utils/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["_"];
function factory(_){// jshint validthis:true
// jshint latedef:false
return{isFormEmpty:isFormEmpty,areFormsEmpty:areFormsEmpty,extractElements:extractElements};// ---
/**
     * Check if a custom form is completely empty
     *
     * @param  {Object}  form - custom form
     *
     * @return {Boolean}      - is empty
     *
     * @tested
     */function isFormEmpty(form){var isEmpty=true;var elements=_.chain(form.formSections).map(function(section){return section.formRows;}).flatten().map(function(row){return row.formElements;}).flatten().value();_.each(elements,function(element){// if it's falsy set value
// and break the loop by returning it
isEmpty=!!!element.value;return isEmpty;});return isEmpty;}/**
     * Check if collection of custom forms is completely empty
     *
     * @param  {Array} forms - collection of custom forms
     *
     * @return {Boolean}     - is empty
     *
     * @tested
     */function areFormsEmpty(forms){var isEmpty=true;_.each(forms,function(form){// if it's falsy set value
// and break the loop by returning it
isEmpty=isFormEmpty(form);return isEmpty;});return isEmpty;}/**
     * Flatten out elements to only deal
     * with id's and values
     *
     * @param  {Array} sections - Array of sections.
     * @return {Array}          - Array containing all elements.
     */function extractElements(sections){return _.reduce(sections,function(elements,section){// TODO save this each
// and flatten it before hand
_.each(section.formRows,function(row){if(row.formElements&&row.formElements.length){elements=elements.concat(_.map(row.formElements,function(element){return{id:element.id,value:element.value};}));}});return elements;},[]);}}module.exports=factory;});
